import { IAddressInstallationStandard } from "@nju/data-access-portal-wwt";
import { generateInstallationStandardTexts } from "@nju/feature-portal-offers";
import { Icon } from "@nju/icons";
import { BlockText, Text } from "@nju/ui";

interface ISFHInfoProps {
  installationStandard: IAddressInstallationStandard | undefined;
  isSfh: boolean | undefined;
}

export function SFHInfo({ installationStandard, isSfh }: ISFHInfoProps) {
  const generatedTextFromInstallationToken = generateInstallationStandardTexts({
    installationStandard,
    isSfh,
    variant: "portal",
  });

  return (
    <div className="flex items-start basis-full from-tablet:basis-1/2">
      <Icon
        className="mr-3 mt-2 w-[24px] h-[24px] from-tablet:w-[32px] from-tablet:h-[32px]"
        name="house"
        tone="accent"
      />
      <div className="flex-1">
        <Text
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
        >
          szczegóły instalacji
        </Text>
        <BlockText
          className="block"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "l",
          }}
          weight="bold"
        >
          {generatedTextFromInstallationToken}
        </BlockText>
      </div>
    </div>
  );
}
